module.exports = __webpack_public_path__ + "img/Hospital.ad0d49c.png";